module.exports = global["sdbb_survey_help"] = require("-!/app/node_modules/ts-loader/index.js??ref--4!./help.ts");